import script from "./TeacherDashboardView.vue?vue&type=script&setup=true&lang=js"
export * from "./TeacherDashboardView.vue?vue&type=script&setup=true&lang=js"

import "./TeacherDashboardView.vue?vue&type=style&index=0&id=0a7e257a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a7e257a"]])

export default __exports__